/**
 * * Ответ при получении CheckEstimate
 */
export class CheckEstimateResponseModel {
  /**
   * * Индификатор который показывает пригласили ли пользователя на оценку задачи
   */
  Invite: boolean = false;
  constructor(obj?: Partial<CheckEstimateResponseModel>) {
    if (obj) {
      Object.assign(this, obj);
    }
  }
}
